import React, {useState, useRef} from 'react';

import * as S from '../DetailsPageLayout.styles';
import ContentContainer from '../../common/ContentContainer/ContentContainer';

import {
  ContentWrapperStyle,
  HeadingTextWrapperStyle,
  HeadingTextStyle,
  MainContentTextStyle,
} from './AboutProperties.styles';

import {
  detailsNavigationIdsAndValues,
  detailsNavigationIds,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const AboutProperties = ({text = '', data = ''}) => {
  return (
    <S.WrapperSection id={detailsNavigationIds.aboutProperty}>
      <S.WrapperDiv>
        <MainContentTextStyle>
          <HeadingTextWrapperStyle>
            <HeadingTextStyle>{text}</HeadingTextStyle>
          </HeadingTextWrapperStyle>
          <ContentContainer
            heightToBeVisible={102}
            scrollToId={detailsNavigationIdsAndValues.aboutProperty.id}
          >
            <MainContentTextStyle dangerouslySetInnerHTML={{__html: data}}></MainContentTextStyle>
          </ContentContainer>
        </MainContentTextStyle>
      </S.WrapperDiv>
    </S.WrapperSection>
  );
};

export default AboutProperties;
